import React from 'react';
import { useIntl, useHistory } from 'umi';
import './index.scss';

export default function TableNodata(props: any) {
  const { formatMessage } = useIntl();
  const {
    onClickNodata = () => { },
    info = formatMessage({ id: 'dbi_info_following_nodata' }),
    handleInfo = formatMessage({ id: 'dbi_info_following_backto_orginal' })
  } = props;
  return (
    <div>
      <span> {info}</span>&nbsp;
      <span className="following-table-nodata-text" onClick={onClickNodata}>
        {handleInfo}
      </span>
    </div>
  );
}
